module.exports = __webpack_public_path__ + "img/faq-grid-06.d9540714.jpg";